"use client";

import { useCallback } from "react";
import { localeToIntl } from "@/lib/i18n/locales";
import type { TranslationKey } from "@/lib/i18n/locales";
import { useLocaleContext, useDictContext } from "@/lib/locale-context";

export function useLocale() {
  return useLocaleContext();
}

export function useIntlLocale(): string {
  return localeToIntl(useLocale());
}

export function useT() {
  const dict = useDictContext();

  return useCallback(
    (key: TranslationKey, values?: Record<string, string | number>) => {
      let value: string = (dict as Record<string, string>)[key] ?? key;

      if (values) {
        for (const [name, replacement] of Object.entries(values)) {
          value = value.replaceAll(`{${name}}`, String(replacement));
        }
      }

      return value;
    },
    [dict]
  );
}
